/* Telcoparts cart-add intercept — replaces redirect-to-cart with a self-contained toast.
   Targets TP forms only: .tp-pdp-form (PDP) and forms inside .tp-product-card (collection + search) */
(function () {
  const TOAST_ID = 'tp-cart-toast';
  const STYLE_ID = 'tp-cart-toast-style';

  function getCartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function getCartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function isTpForm(form) {
    return form.classList.contains('tp-pdp-form') || !!form.closest('.tp-product-card');
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${TOAST_ID} {
        position: fixed;
        top: 100px;
        right: 24px;
        width: 380px;
        max-width: calc(100vw - 32px);
        background: #fff;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        box-shadow: 0 20px 40px -8px rgba(34, 45, 74, 0.18), 0 4px 12px rgba(34, 45, 74, 0.08);
        padding: 1.6rem 1.8rem 1.8rem;
        font-family: var(--font-body-family, inherit);
        font-style: var(--font-body-style, normal);
        z-index: 9999;
        opacity: 0;
        transform: translateY(-10px) scale(0.98);
        transition: opacity 0.25s ease, transform 0.25s cubic-bezier(0.22, 1, 0.36, 1);
        pointer-events: none;
        visibility: hidden;
      }
      #${TOAST_ID}.tp-toast-show { opacity: 1; transform: translateY(0) scale(1); pointer-events: auto; visibility: visible; }
      .tp-toast-head { display: flex; align-items: center; gap: 0.8rem; padding-bottom: 1.2rem; border-bottom: 1px solid #F1F5F9; margin-bottom: 1.2rem; }
      .tp-toast-check { display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border-radius: 50%; background: #2aa42f; color: #fff; flex-shrink: 0; }
      .tp-toast-check svg { width: 12px; height: 12px; }
      .tp-toast-title { font-family: var(--font-heading-family, inherit); font-weight: var(--font-heading-weight, 600); font-size: 1.6rem; color: #222d4a; line-height: 1.3; flex: 1; letter-spacing: 0.01em; }
      #${TOAST_ID}.tp-toast-error .tp-toast-check { background: #ff0400; }
      #${TOAST_ID}.tp-toast-error .tp-toast-title { color: #ff0400; }
      .tp-toast-product { display: flex; gap: 1.2rem; align-items: flex-start; margin-bottom: 1.6rem; }
      .tp-toast-product-img { width: 56px; height: 56px; flex-shrink: 0; background: #F8FAFC; border-radius: 8px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
      .tp-toast-product-img img { max-width: 100%; max-height: 100%; object-fit: contain; }
      .tp-toast-product-info { flex: 1; min-width: 0; }
      .tp-toast-product-name { font-family: var(--font-heading-family, inherit); font-weight: var(--font-heading-weight, 600); font-size: 1.35rem; color: #222d4a; line-height: 1.35; margin-bottom: 0.3rem; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
      .tp-toast-product-variant { font-size: 1.15rem; color: #64748B; line-height: 1.3; margin-bottom: 0.4rem; }
      .tp-toast-product-price { font-size: 1.35rem; font-weight: 700; color: #222d4a; }
      .tp-toast-error-body { font-size: 1.3rem; color: #475569; line-height: 1.4; margin-bottom: 1.6rem; }
      .tp-toast-actions { display: flex; gap: 0.8rem; }
      .tp-toast-btn { flex: 1; padding: 1rem 1.2rem; border-radius: 8px; font-family: var(--font-button-family, inherit); font-weight: var(--font-button-weight, 600); font-size: 1.3rem; cursor: pointer; text-decoration: none; text-align: center; border: 1.5px solid #222d4a; transition: background 0.15s, color 0.15s, border-color 0.15s; line-height: 1.2; }
      .tp-toast-btn-primary { background: #2aa42f; border-color: #2aa42f; color: #fff; }
      .tp-toast-btn-primary:hover { background: #228a27; border-color: #228a27; }
      .tp-toast-btn-secondary { background: #fff; color: #222d4a; }
      .tp-toast-btn-secondary:hover { background: #222d4a; color: #fff; }
      .tp-toast-close { position: absolute; top: 10px; right: 12px; background: none; border: none; width: 28px; height: 28px; border-radius: 50%; color: #94A3B8; cursor: pointer; padding: 0; line-height: 1; display: inline-flex; align-items: center; justify-content: center; transition: background 0.15s, color 0.15s; }
      .tp-toast-close:hover { background: #F1F5F9; color: #222d4a; }
      .tp-toast-close svg { width: 14px; height: 14px; }
      @media (max-width: 600px) {
        #${TOAST_ID} { top: 80px; right: 12px; left: 12px; width: auto; padding: 1.4rem 1.6rem 1.6rem; }
        .tp-toast-product-img { width: 48px; height: 48px; }
      }
    `;
    document.head.appendChild(style);
  }

  function ensureToastEl() {
    let toast = document.getElementById(TOAST_ID);
    if (toast) return toast;
    toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    return toast;
  }

  const CHECK_SVG = '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.3954L4.55005 10L0 5.3555L1.36703 3.9601L4.55005 7.20919L10.633 1L12 2.3954Z" fill="currentColor"/></svg>';
  const CLOSE_SVG = '<svg viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.431 7.431a.5.5 0 1 0 .707-.707L9.712 8.546l7.431-7.431A.5.5 0 1 0 16.436.408L9.005 7.839 1.572.408a.5.5 0 0 0-.707.707l7.433 7.431-7.433 7.432Z" fill="currentColor"/></svg>';

  function getHeaderBottom() {
    const candidates = [
      document.querySelector('sticky-header'),
      document.querySelector('.header-wrapper'),
      document.querySelector('header.header'),
      document.querySelector('.shopify-section-header')
    ].filter(Boolean);
    let maxBottom = 0;
    candidates.forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.bottom > maxBottom) maxBottom = r.bottom;
    });
    return Math.max(maxBottom, 0);
  }

  let hideTimer = null;
  function showToast(data) {
    injectStyles();
    const toast = ensureToastEl();
    const isError = !!data.isError;
    toast.classList.toggle('tp-toast-error', isError);

    let body;
    if (isError) {
      body = `<div class="tp-toast-error-body">${escapeHtml(data.errorMessage || 'Something went wrong. Please try again.')}</div>`;
    } else {
      const imgSrc = data.image ? buildImgSrc(data.image, 120) : null;
      const imgHtml = imgSrc ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(data.productTitle || '')}" loading="lazy" width="56" height="56">` : '';
      const variantHtml = data.variantTitle && data.variantTitle !== 'Default Title' ? `<div class="tp-toast-product-variant">${escapeHtml(data.variantTitle)}</div>` : '';
      const priceHtml = data.priceFormatted ? `<div class="tp-toast-product-price">${escapeHtml(data.priceFormatted)}</div>` : '';
      body = `
        <div class="tp-toast-product">
          <div class="tp-toast-product-img">${imgHtml}</div>
          <div class="tp-toast-product-info">
            <div class="tp-toast-product-name">${escapeHtml(data.productTitle || 'Item')}</div>
            ${variantHtml}
            ${priceHtml}
          </div>
        </div>
      `;
    }

    toast.innerHTML = `
      <button type="button" class="tp-toast-close" aria-label="Close">${CLOSE_SVG}</button>
      <div class="tp-toast-head">
        <span class="tp-toast-check">${CHECK_SVG}</span>
        <span class="tp-toast-title">${isError ? 'Could not add to cart' : 'Added to cart'}</span>
      </div>
      ${body}
      <div class="tp-toast-actions">
        <a href="${getCartUrl()}" class="tp-toast-btn tp-toast-btn-primary">View cart</a>
        <button type="button" class="tp-toast-btn tp-toast-btn-secondary" data-tp-toast-dismiss>Continue</button>
      </div>
    `;
    requestAnimationFrame(() => toast.classList.add('tp-toast-show'));
    toast.querySelector('.tp-toast-close').addEventListener('click', hideToast);
    toast.querySelector('[data-tp-toast-dismiss]').addEventListener('click', hideToast);
    clearTimeout(hideTimer);
    if (!isError) hideTimer = setTimeout(hideToast, 5000);

  }

  function hideToast() {
    const toast = document.getElementById(TOAST_ID);
    if (toast) toast.classList.remove('tp-toast-show');
    clearTimeout(hideTimer);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function buildImgSrc(url, width) {
    if (!url) return null;
    if (url.indexOf('?') !== -1) return url;
    return url.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_' + width + 'x.$1$2');
  }

  function formatMoney(cents) {
    const rawFmt = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '€{{amount}}';
    const fmt = rawFmt.replace(/<[^>]*>/g, '').trim();
    const dutchValue = (cents / 100).toFixed(2).replace('.', ',');
    const noDecimals = Math.round(cents / 100).toString();
    const thousandsValue = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, thousandsValue)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, thousandsValue)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, thousandsValue)
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, noDecimals);
  }

  function updateCartBubbleDirect(itemCount) {
    document.querySelectorAll('.tph-cart-count').forEach(el => {
      el.textContent = itemCount;
      el.classList.toggle('is-empty', itemCount === 0);
    });

    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      cartIcon.classList.toggle('header__icon--cart-empty', itemCount === 0);
      let bubble = cartIcon.querySelector('.cart-count-bubble');
      if (itemCount > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          cartIcon.appendChild(bubble);
        }
        const span = bubble.querySelector('span[aria-hidden="true"]');
        if (span && itemCount < 100) span.textContent = itemCount;
      } else if (bubble) {
        bubble.remove();
      }
    }
  }

  async function refreshCartBubble() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      updateCartBubbleDirect(cart.item_count);
    } catch (e) { /* ignore */ }
  }

  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.getAttribute('aria-busy') === 'true') return;
    if (submitBtn) {
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.classList.add('loading');
    }

    const formData = new FormData(form);

    try {
      const res = await fetch(getCartAddUrl() + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();

      if (!res.ok || data.status) {
        showToast({
          isError: true,
          errorMessage: data.description || data.message || 'Something went wrong. Please try again.'
        });
        return;
      }

      showToast({
        productTitle: data.product_title || data.title || 'Item',
        variantTitle: data.variant_title,
        image: data.featured_image && data.featured_image.url ? data.featured_image.url : (data.image || null),
        priceFormatted: typeof data.price === 'number' ? formatMoney(data.price * (data.quantity || 1)) : null
      });

      refreshCartBubble();
    } catch (err) {
      console.warn('TP cart intercept failed:', err);
      form.submit();
    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute('aria-busy');
        submitBtn.classList.remove('loading');
      }
    }
  }

  function attach(form) {
    if (form.dataset.tpCartIntercept === '1') return;
    if (!isTpForm(form)) return;
    form.dataset.tpCartIntercept = '1';
    form.addEventListener('submit', handleSubmit);
  }

  function initAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
